export default "__VITE_ASSET__C$_sBkry__"